<script>
export default {
    food_drinks: "nourriture & boissons",
    shopping: "shopping",
    home: "maison",
    transport: "transports",
    vehicles: "véhicules",
    entertainment: "divertissement",
    communication_pc: "communication pc",
    financial_expenses: "dépenses financières",
    income: "revenus",
    other: "autre",
    bars_venues: "bars & lieux",
    restaurants_fast_food: "restaurants & fast-food",
    groceries: "courses",
    clothing_shoes: "vêtements & chaussures",
    pets: "animaux domestiques",
    beauty_wellness: "beauté & bien-être",
    stationery_tools: "papeterie & outils",
    home_garden: "maison & jardin",
    electronics_accessories: "électronique, accessoires",
    pharmacy: "pharmacie",
    kids: "enfants",
    jewelry_accessories: "bijoux & accessoires",
    gift_expenses: "dépenses cadeaux",
    family_help: "aide familiale",
    leisure: "loisirs",
    rent: "loyer",
    property_insurance: "assurance immobilière",
    condominium: "copropriété",
    energy_utilities: "énergie & services",
    maintenance: "entretien",
    mortgage: "hypothèque",
    taxi: "taxi",
    public_transport: "transports publics",
    travel: "voyages",
    business_trips: "voyages d'affaires",
    vehicle_insurance: "assurance véhicules",
    fuel: "carburant",
    vehicle_maintenance: "entretien véhicules",
    rentals: "locations",
    parking: "parking",
    tolls: "péages",
    alcohol: "alcool",
    tobacco: "tabac",
    culture_sports_events: "culture, événements sportifs",
    donations_charity: "dons, charité",
    events: "événements",
    wedding: "mariage",
    education_development: "formation, développement",
    hobbies: "loisirs",
    books_audio_subscriptions: "livres, audio, abonnements",
    lotteries_gambling: "loteries & jeux d'argent",
    health: "santé",
    sports_fitness: "sport, fitness",
    tv_streaming: "tv & streaming",
    holidays: "vacances",
    hotels: "hôtels",
    internet: "internet",
    postal_services: "services postaux",
    software_apps_games: "logiciels, apps & jeux",
    phone: "téléphone",
    insurance: "assurances",
    consulting: "consultation",
    fines: "amendes",
    loans_interest: "prêts & intérêts",
    taxes: "impôts",
    taxes_fees: "impôts, frais",
    real_estate: "biens immobiliers",
    movable_goods: "biens mobiliers",
    financial_investments: "investissements financiers",
    collections: "recouvrements",
    savings: "économies",
    checks: "chèques",
    coupons: "coupons",
    family_allowance: "allocation familiale",
    rental_income: "revenus locatifs",
    interest_dividends: "intérêts, dividendes",
    loans_rentals: "prêts, locations",
    gifts: "cadeaux",
    refunds: "remboursements (impôts, achats)",
    salary: "salaire",
    sales: "ventes",
    transfer: "transfert",
    //payment methods
    cash: "espèces",
    credit_card: "carte de crédit",
    debit_card: "carte de débit",
    transfer_back: "virement",
    check: "chèque",
    // currencies
    us_dollar: "dollar américain",
    euro: "euro",
    british_pound: "livre sterling",
    japanese_yen: "yen japonais",
    swiss_franc: "franc suisse",
    canadian_dollar: "dollar canadien",
    australian_dollar: "dollar australien",
    new_zealand_dollar: "dollar néo-zélandais",
    swedish_krona: "couronne suédoise",
    norwegian_krone: "couronne norvégienne",
    danish_krone: "couronne danoise",
    singapore_dollar: "dollar de Singapour",
    hong_kong_dollar: "dollar de Hong Kong",
    chinese_yuan: "yuan chinois",
    russian_ruble: "rouble russe",
    indian_rupee: "roupie indienne",
    indonesian_rupiah: "roupie indonésienne",
    brazilian_real: "réal brésilien",
    mexican_peso: "peso mexicain",
    argentine_peso: "peso argentin",
    dues_grants: "cotisations, subventions",
    pastry_shop: "bar, pâtisserie",
    pub: "pub",
    transportation: "transports",
    investments: "investissements",
    food_beverages: "nourriture & boissons",
    computer_communication: "communication pc",
    wallet_name: "Nom du portefeuille",
    months: {
        jan: 'Jan',
        january: 'Janvier',
        feb: 'Fév',
        february: 'Février',
        mar: 'Mar',
        march: 'Mars',
        apr: 'Avr',
        april: 'Avril',
        may: 'Mai',
        jun: 'Juin',
        june: 'Juin',
        jul: 'Juil',
        july: 'Juillet',
        aug: 'Aoû',
        august: 'Août',
        sep: 'Sep',
        september: 'Septembre',
        oct: 'Oct',
        october: 'Octobre',
        nov: 'Nov',
        november: 'Novembre',
        dec: 'Déc',
        december: 'Décembre',
    },
    bank_accounts: {
        bank: 'Banque',
        cache: 'Espèces',
        "credit-card": 'Carte de Crédit',
        "credit-card-revolving": 'Carte de Crédit Revolving',
        investment: 'Investissement',
        loan: 'Prêt',
        other: 'Autre',
        "prepaid-card": 'Carte Prépayée',
        voucher: 'Bon'
    },
    stats_by_category: 'Statistiques par catégorie',
    stats_by_tags: 'Statistiques par tag',
}
</script>
